/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Head from 'next/head';
import Footer24 from '../../organisms/Footer24';
import Styles from './EmprestimoGarantiaCarroApp.css';
import HeaderEmbedSim from '@/components/organisms/HeaderEmbedSim';

function EmprestimoGarantiaCarroApp() {
  return (
    <>
      <Head>
        <title>Emprestimo Garantia Carro App | Santander Financiamentos</title>
        <meta name="Description" content="" />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/emprestimo-garantia-carro-app.html"
        />
        <meta name="robots" content="noindex, nofollow, nosnippet, noarchive" />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}

        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
      </Head>
      {/* <Header24 disableMenu isHome24 /> */}
      <HeaderEmbedSim />
      <body>
        <div className="embed-sim">
          <iframe
            className="embed-sim-iframe"
            // src="https://pre.emprestimosim.com.br/app/#/login/signInPre"
            src="https://emprestimosim.com.br/app/#/login/signInPre"
            title="Iframe com a página do Emprestimo SIM"
          />
        </div>
      </body>
      {/* <Footer24 /> */}
      <style jsx>{Styles}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroApp;
